import React, { useState } from 'react';
import { IoMdClose } from 'react-icons/io'
import { CgMenuRight } from 'react-icons/cg'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

const menuVariants = {
  hidden: {
    x: '100%',
    opacity: 0
  },
  show: {
    x: 0,
    opacity: 1,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.9]
    }
  }
}

const MobileNav = () => {
  const [openMenu, setOpenMenu] = useState(false)
  return (<nav className='text-text-grey xl:hidden'>
    <div onClick={() => setOpenMenu(true)} className='text-3xl cursor-pointer'>
      <CgMenuRight />
    </div>
    <motion.div variants={menuVariants} initial='hidden' animate={openMenu? 'show' : ''} 
    className='bg-white shadow-2xl w-full absolute top-0 right-0 max-w-xs h-screen z-20 flex flex-col items-center justify-center'>
      <div onClick={() => setOpenMenu(false)} className='text-4xl absolute z-30 left-4 top-14 text-primary cursor-pointer hover:text-grey transition-colors'><IoMdClose /></div>
      <ul className='flex flex-col items-center justify-center gap-y-8 text-primary font-bold text-3xl font-primary'>
        <li><Link to={'/'} className='hover:text-grey transition-colors duration-300'>Home</Link></li>
        <li><Link to={'/contact'} className='hover:text-grey transition-colors duration-300'>Contact</Link></li>
        <li><Link to={'/portfolio'} className='hover:text-grey transition-colors duration-300'>Portfolio</Link></li>
        <li><Link to={'/about'} className='hover:text-grey transition-colors duration-300'>About</Link></li>
      </ul>
    </motion.div>
  </nav>);
};

export default MobileNav;
